import pageHeroBg from "@/assets/schober/hero.webp";
/**
 * Page hero matching the original site:
 *  - Full-width background image (boxes/window scene by default)
 *  - Dark navy overlay tint
 *  - Left-of-center title (white, uppercase) inside a thin outlined box decoration
 *  - Optional subtitle in orange below the title
 */
export function PageHero({
  title,
  subtitle,
  image = pageHeroBg,
}: {
  title: string;
  subtitle?: string;
  image?: string;
}) {
  return (
    <section className="relative h-[260px] overflow-hidden md:h-[420px]">
      <img
        src={image}
        alt=""
        aria-hidden
        loading="eager"
        decoding="async"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-brand-navy/18" aria-hidden />
      <div className="absolute inset-y-0 left-0 w-full bg-brand-navy/60 md:w-1/2 md:bg-brand-navy/70" aria-hidden />

      <div className="relative z-10 mx-auto flex h-full w-full max-w-[1920px] items-center px-4 sm:px-6 lg:px-0">
        <div className="w-full md:ml-[15%] md:max-w-[620px]">
          <div className="absolute -inset-4 -z-10 h-[220px] max-w-xl ml-120 top-[100px] rounded-sm border-10 border-white/30" aria-hidden />
          <div className="relative px-6 py-8 md:px-9 md:py-10">
            <h1 className="font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl md:text-[4.4rem]">
              {title}
            </h1>
            {subtitle && (
              <p className="mt-3 font-display text-xl font-semibold text-brand-orange-on-dark sm:text-2xl md:text-[2.1rem]">
                {subtitle}
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
